<template>
  <div class="subject">
    <div class="subject-head" v-if="appVersion === 'dd'">
      <div class="icon" @click="() => this.$router.back()">
        <i class="iconfont icon-arrow-down"></i>
      </div>
      <h3 class="title">选择学科</h3>
    </div>
    <div class="subject-content">
      <div class="subject-box" v-for="item in subjectArr" :key="item.id">
        <h4 class="subject-title">学科{{ item.id }}</h4>
        <div class="check-box">
          <div class="left-check">阶段</div>
          <div class="right-check" @click="handleStageShow(item.id)">
            <span :class="item.stage ? 'current' : ''">{{ item.stage ? item.stage : '请选择' }}</span>
            <i class="iconfont icon-arrow-down"></i>
          </div>
        </div>
        <div class="line"></div>
        <div class="check-box">
          <div class="left-check">学科</div>
          <div class="right-check" @click="handleSubjectShow(item)">
            <span :class="item.sub ? 'current' : ''">{{ item.sub ? item.sub : '请选择' }}</span>
            <i class="iconfont icon-arrow-down"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="add-subject" @click="handleAdd">
      <div class="add-subject-container">
        <i class="iconfont icon-add"></i>
      </div>
    </div>

    <div class="stage" v-show="boxOneShow">
      <div class="stage-mask" @click="handleStageHide"></div>
      <transition name="slide-down">
        <div class="stage-box" v-show="listOneShow">
          <ul class="stage-list" ref="stageList">
            <li
              v-for="item in stageList"
              :key="item.id"
              :class="item.code == stageIndex ? 'current' : ''"
              @click="handleChangeStage(item)"
            >
              {{ item.text }}
            </li>
          </ul>
          <div class="line"></div>
          <div class="stage-confirm" @click="handleStageConfirm">确定</div>
        </div>
      </transition>
    </div>

    <div class="stage" v-show="boxTwoShow">
      <div class="stage-mask" @click="handleSubjectHide"></div>
      <transition name="slide-down">
        <div class="stage-box current" v-show="listTwoShow">
          <ul class="stage-list">
            <li
              v-for="item in subjectList"
              :key="item.id"
              :class="item.id == subIndex ? 'current' : ''"
              @click="handleChangeSub(item)"
            >
              {{ item.name }}
            </li>
          </ul>
          <div class="line"></div>
          <div class="stage-confirm" @click="handleSubConfirm">确定</div>
        </div>
      </transition>
    </div>

    <div class="confirm" @click="handleConfirm">确定</div>
  </div>
</template>

<script>
import {dictGetByType, subjectByGrade} from '@/api/dd'
export default {
  name: 'check-subject',
  data() {
    return {
      stageList: [],
      subjectList: [],
      boxOneShow: false,
      boxTwoShow: false,
      listOneShow: false,
      listTwoShow: false,
      subjectLen: 0,
      subjectArr: [
        // {
        //   id: 1,
        //   stage: "",
        //   sub: "",
        // },
      ],
      subIdList: [],
      currentIndex: null,
      stageIndex: null,
      subIndex: null,
      changeStageVal: '',
      changeSubVal: '',
      code: null
    }
  },
  methods: {
    handleStageShow(id) {
      this.boxOneShow = true
      this.listOneShow = true
      this.currentIndex = id
    },
    handleStageHide() {
      this.listOneShow = false
      setTimeout(() => {
        this.boxOneShow = false
        this.currentIndex = null
        this.stageIndex = null
      }, 300)
    },
    handleSubjectShow(item) {
      if (item.stageId) {
        this.getAllSubject(item.stageId)
        this.boxTwoShow = true
        this.listTwoShow = true
        this.currentIndex = item.id
      }
    },
    handleSubjectHide() {
      this.listTwoShow = false
      setTimeout(() => {
        this.boxTwoShow = false
        this.currentIndex = null
        this.subIndex = null
      }, 300)
    },
    handleAdd() {
      if (this.subjectLen >= 1) {
        this.$Toast.fail('当前只能选择1个')
        return false
      } else {
        this.subjectLen += 1
        const obj = {
          id: this.subjectLen,
          stageId: '',
          stage: '',
          sub: '',
          subjectId: ''
        }
        this.subjectArr = [...this.subjectArr, obj]
      }
    },
    handleChangeStage(item) {
      this.changeStageVal = item.text
      this.stageIndex = item.code
      this.code = item.code
    },
    handleChangeSub(item) {
      this.changeSubVal = item.name
      this.subIndex = item.id
    },
    handleStageConfirm() {
      const arr = this.subjectArr.map(item => {
        if (item.id === this.currentIndex) {
          item.stage = this.changeStageVal
          item.stageId = this.stageIndex
          item.sub = ''
          item.subjectId = ''
        }
        return item
      })
      this.subjectArr = arr
      this.changeStageVal = ''
      this.handleStageHide()
      this.getAllSubject(this.code)
    },
    handleSubConfirm() {
      const arr = this.subjectArr.map(item => {
        if (item.id === this.currentIndex) {
          item.sub = this.changeSubVal
          item.subjectId = this.subIndex
        }
        return item
      })
      this.subIdList.push(this.subIndex)
      this.subjectArr = arr
      this.changeSubVal = ''
      this.handleSubjectHide()
    },
    handleConfirm() {
      const flag = this.subjectArr.every(item => {
        return item.sub !== '' && item.stage !== ''
      })
      if (flag) {
        const subject = JSON.stringify(this.subjectArr)
        sessionStorage.setItem('subject', subject)
        const subIdList = JSON.stringify(this.subIdList)
        sessionStorage.setItem('subIdList', subIdList)
        this.$router.back()
      } else {
        // 提示
        this.$Toast.fail('请完善当前学科信息')
        return false
      }
    },
    /* 全部学段 */
    getAllGrade() {
      const params = {type: 'stage'}
      dictGetByType(params).then(res => {
        this.stageList = res.data
      })
    },
    /* 全部科目 接口 */
    getAllSubject(periodId) {
      const params = {
        subjectType: '378953758199259136',
        periodId
      }
      // 不传 获取 全部科目 传 学段periodId 获取对应的
      this.subjectList = []
      subjectByGrade(params).then(res => {
        this.subjectList = res.data
      })
    }
  },
  created() {
    // eslint-disable-next-line no-unused-expressions
    sessionStorage.getItem('subject') ? (this.subjectArr = JSON.parse(sessionStorage.getItem('subject'))) : []
    // eslint-disable-next-line no-unused-expressions
    sessionStorage.getItem('subIdList') ? (this.subIdList = JSON.parse(sessionStorage.getItem('subIdList'))) : []
    this.getAllGrade()
  }
}
</script>

<style lang="scss" scoped>
.subject {
  width: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
  .subject-head {
    position: relative;
    width: 100%;
    height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
    background-color: #fff;
    .icon {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 100%;
      i {
        display: inline-block;
        font-size: 20px;
        font-weight: 700;
        transform: rotate(180deg);
      }
    }
    .title {
      line-height: 50px;
      font-size: 17px;
      font-weight: 700;
      text-align: center;
    }
  }
  .subject-content {
    margin-bottom: 10px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    .subject-box {
      margin-top: 16px;
      width: 100%;
      padding: 16px 17px;
      box-sizing: border-box;
      border-radius: 8px;
      background-color: #fff;
      .subject-title {
        color: #909399;
        font-size: 14px;
        margin-bottom: 42px;
      }
      .check-box {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .left-check {
          font-size: 15px;
          color: #303133;
          font-weight: bold;
        }
        .right-check {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          span {
            color: #c0c4cc;
            font-size: 14px;
            &.current {
              color: #303133;
            }
          }
          i {
            margin-left: 7.5px;
            margin-top: 2px;
            font-size: 14px;
            color: #909399;
          }
        }
      }
      .line {
        margin: 27px 0;
        width: 100%;
        height: 1px;
        background-color: #eef1f3;
      }
    }
  }
  .add-subject {
    padding: 0 16px 57px;
    width: 100%;
    box-sizing: border-box;
    .add-subject-container {
      width: 100%;
      padding: 0 16px;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 48px;
      box-sizing: border-box;
      border-radius: 8px;
      i {
        font-size: 28px;
        color: #c0c4cc;
      }
    }
  }
  .stage {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    .stage-mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
    }
    .stage-box {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 40%;
      border-radius: 12px 12px 0 0;
      background-color: #fff;
      z-index: 99;
      &.current {
        height: 70%;
      }
      .stage-list {
        flex: 1;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: scroll;
        li {
          flex: 0 0 50px;
          height: 50px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-top: 1px solid transparent;
          border-bottom: 1px solid transparent;
          box-sizing: border-box;
          &.current {
            color: #4568f3;
            border-color: #f4f6f9;
            border-color: #f4f6f9;
            &:first-child {
              border-top: 1px solid transparent;
            }
          }
        }
      }
      .stage-confirm {
        flex: 0 0 50px;
        width: 100%;
        height: 50px;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        text-align: center;
        line-height: 50px;
      }
      .line {
        flex: 0 0 12px;
        width: 100%;
        height: 12px;
        background-color: #f4f6f9;
      }
    }
  }
  .confirm {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 47px;
    line-height: 47px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    background: linear-gradient(#4465f3 0%, #4a86f6 100%);
  }
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translate3d(0, 100%, 0);
}
.slide-down-enter-to,
.slide-down-leave {
  transform: translate3d(0, 0, 0);
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.2s linear;
}
</style>
